import ajax from "@/utils/ajax";

const getHomePage = (params) => {
  return ajax({
    url: "/mvideo/videoindex",
    method: "post",
    data: params,
  });
};
const getChannelList = () => {
  return ajax({
    url: "/mvideo/channleList",
    method: "get",
  });
};

const getHotWrods = () => {
  return ajax({
    url: "/mvideo/hotSearch",
    method: "get",
  });
};
const getSearchList = (params) => {
  return ajax({
    url: "/mvideo/getSearchVideoList",
    method: "post",
    data: params,
  });
};

const getAssocationList = (params) => {
  return ajax({
    url: "/mvideo/suggestSearch",
    method: "post",
    data: params,
  });
};

const getVideoList = (params) => {
  return ajax({
    url: "/mvideo/videoList",
    method: "post",
    data: params,
  });
};

const getVideoDetail = (params) => {
  return ajax({
    url: "/mvideo/artDetail",
    method: "post",
    data: params,
  });
};

const getHaoVideoDetail = (params) => {
  return ajax({
    url: "/mvideo/getReVideoDetail",
    method: "post",
    data: params,
  });
};
const getCommentList = (params) => {
  return ajax({
    url: "/mvideo/comment",
    method: "post",
    data: params,
  });
};
const getAlbumVideoDetail = (params) => {
  return ajax({
    url: "mvideo/soapOpera",
    method: "post",
    data: params,
  });
};

const getMarvelList = (params) => {
  return ajax({
    url: "/mvideo/rmuVideoList",
    method: "post",
    data: params,
  });
};

export {
  getHomePage,
  getChannelList,
  getVideoList,
  getVideoDetail,
  getCommentList,
  getHaoVideoDetail,
  getAlbumVideoDetail,
  getMarvelList,
  getSearchList,
  getAssocationList,
  getHotWrods,
};
